import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const CapRollIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M6.49289 3.29289C6.88342 2.90237 7.51658 2.90237 7.90711 3.29289L9.50711 4.89289C9.89763 5.28342 9.89763 5.91658 9.50711 6.30711L7.90711 7.90711C7.51658 8.29763 6.88342 8.29763 6.49289 7.90711C6.19341 7.60763 6.12359 7.16545 6.28344 6.79943C5.52602 7.14701 5 7.91208 5 8.8C5 9.35228 4.55228 9.8 4 9.8C3.44772 9.8 3 9.35228 3 8.8C3 6.73498 4.49031 5.01804 6.45405 4.66604C6.10283 4.27339 6.11578 3.67001 6.49289 3.29289ZM9.58278 7.35074C10.2266 4.84938 12.4961 3 15.2 3C18.4033 3 21 5.59675 21 8.8C21 11.5039 19.1507 13.7734 16.6493 14.4172C16.1145 14.5549 15.5693 14.2329 15.4316 13.698C15.2939 13.1632 15.6159 12.618 16.1508 12.4803C17.7899 12.0584 19 10.5693 19 8.8C19 6.70132 17.2987 5 15.2 5C13.4307 5 11.9416 6.21008 11.5197 7.84926C11.382 8.38411 10.8368 8.7061 10.302 8.56844C9.76711 8.43078 9.44512 7.88559 9.58278 7.35074ZM8.8 11.4C6.70132 11.4 5 13.1013 5 15.2C5 17.2987 6.70132 19 8.8 19C10.8987 19 12.6 17.2987 12.6 15.2C12.6 13.1013 10.8987 11.4 8.8 11.4ZM3 15.2C3 11.9967 5.59675 9.4 8.8 9.4C12.0033 9.4 14.6 11.9967 14.6 15.2C14.6 18.4033 12.0033 21 8.8 21C5.59675 21 3 18.4033 3 15.2ZM20 14.2C20.5523 14.2 21 14.6477 21 15.2C21 17.265 19.5097 18.982 17.5459 19.334C17.8972 19.7266 17.8842 20.33 17.5071 20.7071C17.1166 21.0976 16.4834 21.0976 16.0929 20.7071L14.4929 19.1071C14.1024 18.7166 14.1024 18.0834 14.4929 17.6929L16.0929 16.0929C16.4834 15.7024 17.1166 15.7024 17.5071 16.0929C17.8066 16.3924 17.8764 16.8346 17.7166 17.2006C18.474 16.853 19 16.0879 19 15.2C19 14.6477 19.4477 14.2 20 14.2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

CapRollIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(CapRollIcon);
